<div [formGroup]="formGroup">
  <!-- Struttura and Responsabile in grid layout -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <!-- Struttura -->
    <div>
      <siat-struttura-selector
        formControlName="struttura"
        label="{{ 'SANITARIO.strutturaLabel' | translate }}"
        placeholder="{{ 'SANITARIO.strutturaPlaceholder' | translate }}"
        class="w-full"
        [idStrutturaDefault]="idStrutturaDefault"
      ></siat-struttura-selector>
      @if (!readonly && !disableStruttura && formGroup.get('struttura')?.value) {
        <button type="button" class="bg-transparent border-none p-0 cursor-pointer text-xs mt-1" style="color: #95254f" (click)="clearStruttura()">
          Svuota
        </button>
      }
    </div>
    
    <!-- Responsabile -->
    <div>
      <siat-select-field
        formControlName="responsabile"
        [items]="responsabileOptions"
        label="{{ 'SANITARIO.responsabileLabel' | translate }}"
        placeholder="{{ 'SANITARIO.responsabilePlaceholder' | translate }}"
      ></siat-select-field>
      @if (!readonly && formGroup.get('responsabile')?.value) {
        <button type="button" class="bg-transparent border-none p-0 cursor-pointer text-xs mt-1" style="color: #95254f" (click)="clearResponsabile()">
          Svuota
        </button>
      }
    </div>
  </div>

  <!-- Multiple Ruolo-Date Rows (only shown when struttura is selected) -->
  @if (selectedStruttura) {
    <div class="mt-4">
      <div class="flex items-center my-4">
        <div class="grow border-t border-gray-300"></div>
        <span class="px-4 text-base font-semibold text-gray-700">{{ 'SANITARIO.ruoloLabel' | translate }} e Date</span>
        <div class="grow border-t border-gray-300"></div>
      </div>

      @for (group of ruoloDateGroups; track group; let i = $index) {
        <div [formGroup]="group" class="border pt-4 rounded mb-4">
          <!-- Ruolo, Data Inizio, Data Fine in one row -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <!-- Ruolo -->
            <div>
              <siat-select-field
                [formGroup]="group"
                controlName="ruolo"
                id="id"
                name="name"
                label="{{ 'SANITARIO.ruoloLabel' | translate }}"
                placeholder="{{ 'SANITARIO.ruoloPlaceholder' | translate }}"
                [items]="ruoliOptions"
                class="w-full [&_.siat-error-field]:hidden"
              ></siat-select-field>
              @if (!readonly && group.get('ruolo')?.value) {
                <button type="button" class="bg-transparent border-none p-0 cursor-pointer text-xs mt-1" style="color: #95254f" (click)="clearRuolo(i)">
                  Svuota
                </button>
              }
              <mat-error
                siatErrorField
                [control]="group.get('ruolo')!"
                [label]="'SANITARIO.ruoloLabel' | translate"
              ></mat-error>
            </div>

            <!-- Data Inizio -->
            <siat-datepicker-field
              [formGroup]="group"
              controlName="dataInizio"
              label="{{ 'SANITARIO.dataInizioLabel' | translate }}"
              placeholder="{{ 'SANITARIO.dataInizioPlaceholder' | translate }}"
              class="w-full"
            ></siat-datepicker-field>

            <!-- Data Fine -->
            <siat-datepicker-field
              [formGroup]="group"
              controlName="dataFine"
              label="{{ 'SANITARIO.dataFineLabel' | translate }}"
              placeholder="{{ 'SANITARIO.dataFinePlaceholder' | translate }}"
              class="w-full"
            ></siat-datepicker-field>
          </div>

          <!-- Date range validation error for this specific group -->
          @if (shouldShowDateRangeError(i)) {
            <div class="mb-4 text-red-600 text-sm">
              <div class="flex items-center">
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
                {{ getDateRangeError(i) }}
              </div>
            </div>
          }

          <!-- Duplicate role validation error for this specific group -->
          @if (shouldShowDuplicateRoleError(i)) {
            <div class="mb-4 text-red-600 text-sm">
              <div class="flex items-center">
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
                {{ getDuplicateRoleError(i) }}
              </div>
            </div>
          }

          <!-- Add/Remove Buttons -->
          @if (!readonly) {
            <div class="flex gap-2 items-center justify-end px-4 pb-4 pt-2">
              <button
                type="button"
                mat-mini-fab
                (click)="addRuoloDateEntry()"
                [attr.aria-label]="'SANITARIO.aggiungiLabel' | translate"
                style="border: 2px solid var(--mat-sys-primary) !important; border-radius: 30% !important; background-color: white !important;"
                class="hover:bg-pink-50"
                >
                <mat-icon style="color: var(--mat-sys-primary) !important;">add</mat-icon>
              </button>
              <button
                type="button"
                mat-mini-fab
                (click)="removeRuoloDateEntry(i)"
                [attr.aria-label]="'SANITARIO.rimuoviLabel' | translate"
                style="border: 2px solid var(--mat-sys-primary) !important; border-radius: 30% !important; background-color: white !important;"
                class="hover:bg-pink-50"
                >
                <mat-icon style="color: var(--mat-sys-primary) !important;">delete</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
</div>